import { jsx as _jsx } from "react/jsx-runtime";
import { Markdown } from "../markdown";
export const makeFormattedRenderer = (values, staticContent = []) => ({ translation }) => (_jsx(Markdown, { source: translation, values: values, staticContent: staticContent }));
